import { useTranslation } from 'react-i18next';
import NavigationHeader from 'components/molecules/navigation-header';

import type { FC } from 'react';

const UntrackedInboundCallsHeader: FC = () => {
  const { t } = useTranslation();

  return <NavigationHeader title={t('labels.untrackedInboundCalls')} />;
};

export default UntrackedInboundCallsHeader;
